import React from 'react';
import { Button } from 'shared/components/Button';
import { useAppDispatch } from 'shared/store';
import { logout } from 'shared/store/auth-slice';
import './style.less';

export const NoUserMessage: React.FC = () => {
  const dispatch = useAppDispatch();
  return (
    <div className="NoUserMessage">
      <h1>Your account has been deactivated</h1>
      <p>
        You no longer have access to the organization associated with this account. Please
        contact an administrator and have them re-invite you, or create a new account with
        a different email.
      </p>
      <Button type="primary" size="large" onClick={() => dispatch(logout())}>
        Log out
      </Button>
    </div>
  );
};
